import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorCompanyNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ICompanyModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const ICompanyFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useCompanyHookNae(id: number) : ICompanyModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorCompanyNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Company.schema,
        fields: ICompanyFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
